import Logo from "shared/Logo/Logo";
import SocialsList1 from "shared/SocialsList1/SocialsList1";
import { CustomLink } from "data/types";
import React from "react";
import { useNavigate } from "react-router-dom";

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}

const widgetMenus: WidgetFooterMenu[] = [
  {
    id: "1",
    title: "Company",
    menus: [
      { href: "/", label: "Home" },
      { href: "/about", label: "About Us" },
    ],
  },
  {
    id: "2",
    title: "Products",
    menus: [{ href: "/products", label: "Our Products" }],
  },
  {
    id: "3",
    title: "Support",
    menus: [{ href: "/contact", label: "Contact" }],
  },
  {
    id: "4",
    title: "Product Quick Links",
    menus: [
      {
        href: "/product/3-inch-heavy-sink-coupling",
        label: "3 inch Heavy Sink Coupling",
      },
      {
        href: "/product/3-inch-lite-ms-ss-screw",
        label: "3 inch Lite MS & SS Screw Coupling",
      },
      {
        href: "/product/4-inch-heavy-coupling-with-reducer",
        label: "4 inch Heavy Coupling with Reducer",
      },
      {
        href: "/product/4-inch-jumbo-sink-coupling",
        label: "4 inch Jumbo Sink Coupling",
      },
      {
        href: "/product/4-inch-heavy-royal-sink-coupling",
        label: "4 inch Heavy Royal Sink Coupling",
      },
      {
        href: "/product/4-inch-lite-sink-coupling",
        label: "4 inch Lite Sink Coupling",
      },
    ],
  },
];

const Footer: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = (href: string) => {
    if (/^https?:\/\//i.test(href)) {
      window.open(href, "_blank", "noopener,noreferrer");
    } else {
      navigate(href);
    }
  };

  const renderWidgetMenuItem = (menu: WidgetFooterMenu, index: number) => {
    return (
      <div key={index} className="text-sm">
        <h2 className="font-semibold text-neutral-700 dark:text-neutral-200">
          {menu.title}
        </h2>
        <ul className="mt-5 space-y-4">
          {menu.menus.map((item, mIndex) => (
            <li key={mIndex}>
              <button
                type="button"
                onClick={() => handleClick(item.href)}
                className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white p-0 text-left"
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return (
    <div className="nc-Footer relative py-5 lg:pt-28  border-t border-neutral-200 dark:border-neutral-700">
      <div className="container grid grid-cols-2 gap-y-10 gap-x-5 sm:gap-x-8 md:grid-cols-4 lg:grid-cols-5 lg:gap-x-10 ">
        <div className="grid grid-cols-4 gap-5 col-span-2 md:col-span-4 lg:md:col-span-1 lg:flex lg:flex-col">
          <div className="col-span-2 md:col-span-1">
            <Logo />
          </div>
          <div className="col-span-2 flex items-center md:col-span-3">
            <SocialsList1 className="flex items-center space-x-2 lg:space-x-0 lg:flex-col lg:space-y-3 lg:items-start" />
          </div>
        </div>
        {widgetMenus.map(renderWidgetMenuItem)}
      </div>
      <div className="mt-8 border-t border-neutral-200 dark:border-neutral-700 pt-6">
        <div className="container text-center">
          <span className="text-sm text-neutral-500 dark:text-neutral-400">
            © {new Date().getFullYear()} Devi Plastic. All rights reserved.
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
